import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import { DigiQuoteSettings, QuoteDisplaySettings } from './types';

export type UseUpdateQuoteDisplaySettingsParams = {
  groupId: string;
};

export const getUpdateQuoteDisplaySettingsKey = (
  params: UseUpdateQuoteDisplaySettingsParams,
) => ['suppliers', params.groupId, 'updateQuoteDisplaySettings'] as const;

export const useUpdateQuoteDisplaySettings: MutationFunction<
  DigiQuoteSettings,
  QuoteDisplaySettings,
  [UseUpdateQuoteDisplaySettingsParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { groupId } = params;

  const mutationKey = getUpdateQuoteDisplaySettingsKey(params);
  const request = useRequest(requestOptions);

  return useMutation(
    (body) => {
      return request(`/suppliers/${groupId}/digi_quote_settings`, {
        init: {
          method: 'PATCH',
          body,
        },
      });
    },
    {
      ...queryOptions,
      mutationKey,
    },
  );
};
